/** Firebase web config (FCM + auth). Must match `public/firebase-messaging-sw.js`. */
const FirebaseConfig = {
  apiKey: 'AIzaSyBtjurfRPKVgdfWmv922JF7BVg3sLkRuuw',
  authDomain: 'sabine-92d34.firebaseapp.com',
  projectId: 'sabine-92d34',
  storageBucket: 'sabine-92d34.firebasestorage.app',
  messagingSenderId: '268954616425',
  appId: '1:268954616425:web:2da8c0a9bcedd8e33158f8',
  measurementId: 'G-YQYP0DL807',
}

export default FirebaseConfig
